import dayjs from "dayjs";
import { dateFormat } from "us.collection.admin/constants/NonProductionDays";
import { INonProductionDay } from "us.collection.admin/interfaces";

export function AddOrUpdateNonExecutionDay(this: INonProductionDay) {
  const { id, key, dateRange, reason, criteria } = this;
  return {
    id,
    key,
    dateRange: [
      // dayjs(dateRange[0]).startOf("day").format(dateFormat),
      // dayjs(dateRange[1]).startOf("day").format(dateFormat),
      dayjs(
        (dateRange[0] as any)?.toDate ? (dateRange[0] as any).toDate() : dateRange[0]
      ).startOf("day").format(dateFormat),
      dayjs(
        (dateRange[1] as any)?.toDate ? (dateRange[1] as any).toDate() : dateRange[1]
      ).startOf("day").format(dateFormat),
    ],
    reason,
    criteria,
  };
}
